import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FaLaptop, FaMusic, FaFootballBall, FaFlask, FaBook, FaBus, FaUtensils, FaTree, FaShieldAlt, FaPaintBrush } from 'react-icons/fa';
import LineSeperator from '../ui/LineSeperator';
import '../../stylings/Facilities.css';

gsap.registerPlugin(ScrollTrigger);

const facilities = [
  { icon: <FaLaptop />, title: 'Smart Classes', desc: 'AI-powered digital classrooms with interactive whiteboards and e-learning tools.' },
  { icon: <FaPaintBrush />, title: 'Cultural Activities', desc: 'Dance, drama, music, and art programs to nurture creative talents.' },
  { icon: <FaFootballBall />, title: 'Games & Sports', desc: 'Football, basketball, cricket, athletics, and indoor sports facilities.' },
  { icon: <FaFlask />, title: 'Science Labs', desc: 'Fully equipped Physics, Chemistry, and Biology laboratories.' },
  { icon: <FaBook />, title: 'Library', desc: 'Extensive collection of books, journals, and digital resources.' },
  { icon: <FaBus />, title: 'Transport', desc: 'Safe and reliable school bus service covering all major routes.' },
  { icon: <FaUtensils />, title: 'Cafeteria', desc: 'Hygienic and nutritious meals prepared in a modern kitchen.' },
  { icon: <FaTree />, title: 'Eco Campus', desc: 'Green campus with gardens, plantations, and eco-friendly practices.' },
  { icon: <FaShieldAlt />, title: 'Safety & Security', desc: '24/7 CCTV surveillance and trained security personnel on campus.' },
  { icon: <FaMusic />, title: 'Music Room', desc: 'Dedicated music room with instruments and trained music teachers.' },
];

export default function Facilities() {
  const gridRef = useRef(null);

  useEffect(() => {
    const cards = gridRef.current?.querySelectorAll('.facility-card');
    if (!cards) return;
    gsap.fromTo(
      cards,
      { opacity: 0, scale: 0.8 },
      {
        opacity: 1, scale: 1, duration: 0.5, stagger: 0.1, ease: 'back.out(1.4)',
        scrollTrigger: { trigger: gridRef.current, start: 'top 75%' },
      }
    );
  }, []);

  return (
    <section className="facilities-section">
      <div className="container-fluid px-5">
        <LineSeperator title="Our Facilities" />
        <div className="facilities-grid" ref={gridRef}>
          {facilities.map((f, i) => (
            <div key={i} className="facility-card">
              <div className="facility-icon">{f.icon}</div>
              <h5 className="facility-title">{f.title}</h5>
              <p className="facility-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
